import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  nhiemVuId: null,
  nhiemVuDangCapNhat: {},
  nhiemVuPaging: {},
  tatCaDonViTrongDonViCha: [],
  tatCaCanBoCoQuyenPhanXuLyTrongDonVi: [],
  loaiNhiemVu: [],
  tatCaLoaiNhiemVu: [],
  tatCacCanBoTrongDonVi: [],
  danhSachThuHoiNhiemVu: [],
  danhSachTraLaiNhiemVu: [],
  danhSachSoLuongNhiemVu: [],
  danhSachNhiemVu: [],
  danhSachTrangThai: [],
  danhSachNguoiGiaoNhiemVu: [],
  danhSachDonViCaNhan: {},
  danhSachChiTietVanBanLienQuan: [],
  danhSachChiTietYkienXuLy: [],
  danhSachLichSuPhanXuLy: [],
  trangThaiTinhHinhThucHien: [],
  danhSachTinhHinhThucHienNhiemVu: [],
  danhSachTinhHinhThucHienContgViec: [],
  danhSachPhuongThucNhanNhiemVu: [],
  danhSachLichSuTraLaiNhiemVu: [],
  danhSachLichSuCapNhatTinhHinhNhiemVu: [],
  danhSachLichSuThuHoiNhiemVu: [],
  danhSachVPCPDonDocNhiemVu: [],
  danhSachVPCPTienDoXuLy: [],
  danhSachVPCPDieuChinhNhiemVu: [],
  danhSachGuiTraVPCP: [],
  danhSachLichSuDonDocNhiemVu: [],
  danhSachDemLoaiNhiemVuCaNhan: [],
  danhSachDemLoaiNhiemVuDonVi: [],
  danhSachDemLoaiCongViecDonVi: [],
  danhSachDemLoaiCongViec: [],
  danhSachSoDoLuongNhiemVu: [],
  ketQuaExportDanhSachNhiemVu: [],
  danhSachCotNhiemVuExport: [],
  danhSachHienThiCotNhiemVu: [],
  danhSachHienThiCotNhiemVuCapNhat: [],
  DanhSachDanhMucCapNhat: [],
  DanhSachCotDanhMuc: [],
  danhSachDemLoaiCongViecDV: [],
  danhSachTatCaDonVi: [],
  vanBanTaoNhiemVu: {},
  tabIndex: 1,
  indexTab: 0,
  tabText: "",
  dataFilterDashboard: null,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
